// Sacred geometric frequency maps for BrainLattice
// Colors: delta #4A90E2, theta #9B59B6, alpha #F1C40F, beta #E67E22, gamma #E74C3C

export const SACRED_GEOMETRIES = [
  {
    id: "tree-of-life",
    name: "TREE OF LIFE",
    short: "Tree",
    description: "Kabbalistic 10-sephirot path — the original brain lattice configuration.",
    nodes: [
      { id: "prefrontal", label: "Prefrontal", x: 0.5, y: 0.15, hz: 40, band: "gamma", color: "#E74C3C", desc: "Gamma · Focus" },
      { id: "frontal-l", label: "L Frontal", x: 0.32, y: 0.22, hz: 18, band: "beta", color: "#E67E22", desc: "Beta · Thinking" },
      { id: "frontal-r", label: "R Frontal", x: 0.68, y: 0.22, hz: 14, band: "beta", color: "#E67E22", desc: "Beta · Alertness" },
      { id: "temporal-l", label: "L Temporal", x: 0.18, y: 0.48, hz: 10, band: "alpha", color: "#F1C40F", desc: "Alpha · Calm" },
      { id: "temporal-r", label: "R Temporal", x: 0.82, y: 0.48, hz: 12, band: "alpha", color: "#F1C40F", desc: "Alpha · Relaxed" },
      { id: "parietal-l", label: "L Parietal", x: 0.35, y: 0.42, hz: 8, band: "alpha", color: "#F1C40F", desc: "Alpha · Integration" },
      { id: "parietal-r", label: "R Parietal", x: 0.65, y: 0.42, hz: 9, band: "alpha", color: "#F1C40F", desc: "Alpha · Awareness" },
      { id: "central", label: "Central", x: 0.5, y: 0.35, hz: 432, band: "alpha", color: "#F1C40F", desc: "432 Hz · Reference" },
      { id: "occipital", label: "Occipital", x: 0.5, y: 0.7, hz: 6, band: "theta", color: "#9B59B6", desc: "Theta · Presence" },
      { id: "thalamus", label: "Thalamus", x: 0.5, y: 0.52, hz: 4, band: "theta", color: "#9B59B6", desc: "Theta · Meditation" },
      { id: "brainstem", label: "Brainstem", x: 0.5, y: 0.82, hz: 2, band: "delta", color: "#4A90E2", desc: "Delta · Deep rest" },
      { id: "cerebellum", label: "Cerebellum", x: 0.5, y: 0.92, hz: 0.5, band: "delta", color: "#4A90E2", desc: "Sub-delta · Stillness" },
    ],
    connections: [],
  },
  {
    id: "merkaba",
    name: "MERKABA",
    short: "Merkaba",
    description: "Star Tetrahedron — counter-rotating light vehicle for vertical crown-root coherence.",
    nodes: [
      { id: "crown", label: "Crown", x: 0.5, y: 0.08, hz: 40, band: "gamma", color: "#E74C3C", desc: "Gamma 40 Hz · Crown ignition" },
      { id: "frontal-r", label: "R Frontal", x: 0.78, y: 0.30, hz: 18, band: "beta", color: "#E67E22", desc: "Beta · Right intent" },
      { id: "frontal-l", label: "L Frontal", x: 0.22, y: 0.30, hz: 18, band: "beta", color: "#E67E22", desc: "Beta · Left intent" },
      { id: "temporal-r", label: "R Temporal", x: 0.85, y: 0.55, hz: 12, band: "alpha", color: "#F1C40F", desc: "Alpha · Right field" },
      { id: "temporal-l", label: "L Temporal", x: 0.15, y: 0.55, hz: 12, band: "alpha", color: "#F1C40F", desc: "Alpha · Left field" },
      { id: "pineal", label: "Pineal", x: 0.5, y: 0.5, hz: 936, band: "gamma", color: "#E74C3C", desc: "936 Hz · Pineal axis" },
      { id: "parietal-r", label: "R Parietal", x: 0.78, y: 0.70, hz: 10, band: "alpha", color: "#F1C40F", desc: "Alpha · Right ground" },
      { id: "parietal-l", label: "L Parietal", x: 0.22, y: 0.70, hz: 10, band: "alpha", color: "#F1C40F", desc: "Alpha · Left ground" },
      { id: "thalamus", label: "Thalamus", x: 0.5, y: 0.65, hz: 6, band: "theta", color: "#9B59B6", desc: "Theta · Relay" },
      { id: "brainstem", label: "Root", x: 0.5, y: 0.92, hz: 2, band: "delta", color: "#4A90E2", desc: "Delta 2 Hz · Root anchor" },
    ],
    connections: [
      ["crown", "temporal-r"], ["crown", "temporal-l"], ["crown", "thalamus"],
      ["brainstem", "frontal-r"], ["brainstem", "frontal-l"], ["brainstem", "pineal"],
      ["frontal-r", "frontal-l"], ["temporal-r", "temporal-l"], ["parietal-r", "parietal-l"],
      ["pineal", "crown"], ["pineal", "brainstem"], ["pineal", "thalamus"],
    ],
  },
  {
    id: "metatron",
    name: "METATRON'S CUBE",
    short: "Metatron",
    description: "13-circle Fruit of Life with all 5 Platonic solids — whole-brain non-local resonance.",
    nodes: [
      { id: "pineal", label: "Pineal", x: 0.5, y: 0.5, hz: 528, band: "gamma", color: "#E74C3C", desc: "528 Hz · DNA bindu" },
      { id: "crown", label: "Crown", x: 0.5, y: 0.08, hz: 963, band: "gamma", color: "#E74C3C", desc: "963 Hz · Crown" },
      { id: "prefrontal", label: "Prefrontal", x: 0.5, y: 0.30, hz: 40, band: "gamma", color: "#E74C3C", desc: "Gamma · Insight" },
      { id: "frontal-r", label: "R Frontal", x: 0.71, y: 0.38, hz: 16, band: "beta", color: "#E67E22", desc: "Beta · R cortex" },
      { id: "frontal-l", label: "L Frontal", x: 0.29, y: 0.38, hz: 16, band: "beta", color: "#E67E22", desc: "Beta · L cortex" },
      { id: "temporal-r", label: "R Temporal", x: 0.71, y: 0.62, hz: 10, band: "alpha", color: "#F1C40F", desc: "Alpha · R audio" },
      { id: "temporal-l", label: "L Temporal", x: 0.29, y: 0.62, hz: 10, band: "alpha", color: "#F1C40F", desc: "Alpha · L audio" },
      { id: "parietal-r", label: "R Parietal", x: 0.88, y: 0.50, hz: 8, band: "alpha", color: "#F1C40F", desc: "Alpha · R space" },
      { id: "parietal-l", label: "L Parietal", x: 0.12, y: 0.50, hz: 8, band: "alpha", color: "#F1C40F", desc: "Alpha · L space" },
      { id: "occipital", label: "Occipital", x: 0.5, y: 0.70, hz: 7.83, band: "alpha", color: "#F1C40F", desc: "7.83 Hz · Schumann" },
      { id: "thalamus", label: "Thalamus", x: 0.62, y: 0.50, hz: 6, band: "theta", color: "#9B59B6", desc: "Theta · Relay" },
      { id: "brainstem", label: "Brainstem", x: 0.5, y: 0.92, hz: 2, band: "delta", color: "#4A90E2", desc: "Delta · Root" },
    ],
    connections: [
      ["pineal", "crown"], ["pineal", "prefrontal"], ["pineal", "frontal-r"], ["pineal", "frontal-l"],
      ["pineal", "temporal-r"], ["pineal", "temporal-l"], ["pineal", "parietal-r"], ["pineal", "parietal-l"],
      ["pineal", "occipital"], ["pineal", "thalamus"], ["pineal", "brainstem"],
      ["crown", "parietal-r"], ["crown", "parietal-l"],
      ["brainstem", "parietal-r"], ["brainstem", "parietal-l"],
      ["prefrontal", "occipital"], ["frontal-r", "temporal-l"], ["frontal-l", "temporal-r"],
    ],
  },
  {
    id: "vector-equilibrium",
    name: "VECTOR EQUILIBRIUM",
    short: "VE / 64-Tet",
    description: "Cuboctahedron — Buckminster Fuller's zero-point matrix. All vectors equal.",
    nodes: [
      { id: "crown", label: "Crown N", x: 0.5, y: 0.08, hz: 33, band: "gamma", color: "#E74C3C", desc: "Gamma · N pole" },
      { id: "frontal-r", label: "R Frontal", x: 0.78, y: 0.22, hz: 17, band: "beta", color: "#E67E22", desc: "Beta · NE" },
      { id: "frontal-l", label: "L Frontal", x: 0.22, y: 0.22, hz: 17, band: "beta", color: "#E67E22", desc: "Beta · NW" },
      { id: "parietal-r", label: "R Parietal", x: 0.88, y: 0.5, hz: 10, band: "alpha", color: "#F1C40F", desc: "Alpha · E" },
      { id: "parietal-l", label: "L Parietal", x: 0.12, y: 0.5, hz: 10, band: "alpha", color: "#F1C40F", desc: "Alpha · W" },
      { id: "prefrontal", label: "Prefrontal", x: 0.5, y: 0.30, hz: 13, band: "beta", color: "#E67E22", desc: "Beta · Upper" },
      { id: "pineal", label: "Pineal", x: 0.5, y: 0.5, hz: 432, band: "alpha", color: "#F1C40F", desc: "432 Hz · Center" },
      { id: "occipital", label: "Occipital", x: 0.5, y: 0.70, hz: 8, band: "alpha", color: "#F1C40F", desc: "Alpha · Lower" },
      { id: "temporal-r", label: "R Temporal", x: 0.78, y: 0.78, hz: 11, band: "alpha", color: "#F1C40F", desc: "Alpha · SE" },
      { id: "temporal-l", label: "L Temporal", x: 0.22, y: 0.78, hz: 11, band: "alpha", color: "#F1C40F", desc: "Alpha · SW" },
      { id: "thalamus", label: "Thalamus", x: 0.65, y: 0.5, hz: 6, band: "theta", color: "#9B59B6", desc: "Theta · Inner" },
      { id: "brainstem", label: "Brainstem S", x: 0.5, y: 0.92, hz: 4, band: "theta", color: "#9B59B6", desc: "Theta · S pole" },
    ],
    connections: [
      ["crown", "frontal-r"], ["crown", "frontal-l"], ["crown", "prefrontal"],
      ["frontal-r", "parietal-r"], ["frontal-l", "parietal-l"],
      ["parietal-r", "temporal-r"], ["parietal-l", "temporal-l"],
      ["temporal-r", "brainstem"], ["temporal-l", "brainstem"], ["occipital", "brainstem"],
      ["frontal-r", "frontal-l"], ["temporal-r", "temporal-l"],
      ["pineal", "thalamus"], ["pineal", "prefrontal"], ["pineal", "occipital"],
    ],
  },
  {
    id: "sri-yantra",
    name: "SRI YANTRA",
    short: "Sri Yantra",
    description: "9 interlocking triangles around the central bindu — Tantric manifestation field.",
    nodes: [
      { id: "pineal", label: "Bindu", x: 0.5, y: 0.5, hz: 963, band: "gamma", color: "#E74C3C", desc: "963 Hz · Bindu" },
      { id: "crown", label: "Apex Up", x: 0.5, y: 0.08, hz: 40, band: "gamma", color: "#E74C3C", desc: "Gamma · Shiva apex" },
      { id: "frontal-r", label: "R Frontal", x: 0.85, y: 0.30, hz: 16, band: "beta", color: "#E67E22", desc: "Beta · R intent" },
      { id: "frontal-l", label: "L Frontal", x: 0.15, y: 0.30, hz: 16, band: "beta", color: "#E67E22", desc: "Beta · L intent" },
      { id: "amygdala-r", label: "R Amygdala", x: 0.62, y: 0.45, hz: 639, band: "alpha", color: "#F1C40F", desc: "639 Hz · R heart" },
      { id: "amygdala-l", label: "L Amygdala", x: 0.38, y: 0.45, hz: 639, band: "alpha", color: "#F1C40F", desc: "639 Hz · L heart" },
      { id: "hippocampus-r", label: "R Hippoc.", x: 0.65, y: 0.62, hz: 7.83, band: "alpha", color: "#F1C40F", desc: "7.83 Hz · R memory" },
      { id: "hippocampus-l", label: "L Hippoc.", x: 0.35, y: 0.62, hz: 7.83, band: "alpha", color: "#F1C40F", desc: "7.83 Hz · L memory" },
      { id: "thalamus", label: "Thalamus", x: 0.5, y: 0.35, hz: 6, band: "theta", color: "#9B59B6", desc: "Theta · Relay" },
      { id: "brainstem", label: "Apex Down", x: 0.5, y: 0.92, hz: 2, band: "delta", color: "#4A90E2", desc: "Delta · Shakti apex" },
      { id: "temporal-r", label: "R Temporal", x: 0.85, y: 0.78, hz: 528, band: "alpha", color: "#F1C40F", desc: "528 Hz · R anchor" },
      { id: "temporal-l", label: "L Temporal", x: 0.15, y: 0.78, hz: 528, band: "alpha", color: "#F1C40F", desc: "528 Hz · L anchor" },
    ],
    connections: [
      ["crown", "temporal-l"], ["crown", "temporal-r"], ["temporal-l", "temporal-r"],
      ["brainstem", "frontal-l"], ["brainstem", "frontal-r"], ["frontal-l", "frontal-r"],
      ["amygdala-l", "amygdala-r"], ["hippocampus-l", "hippocampus-r"],
      ["amygdala-l", "hippocampus-r"], ["amygdala-r", "hippocampus-l"],
      ["pineal", "crown"], ["pineal", "brainstem"], ["pineal", "thalamus"],
      ["pineal", "amygdala-l"], ["pineal", "amygdala-r"],
    ],
  },
  {
    id: "torus",
    name: "TOROIDAL FLOW",
    short: "Torus",
    description: "Self-referencing donut field — up the axis, down the outer ring, back through root.",
    nodes: [
      { id: "crown", label: "Crown N", x: 0.5, y: 0.05, hz: 963, band: "gamma", color: "#E74C3C", desc: "963 Hz · N pole" },
      { id: "ring-ur", label: "Upper R", x: 0.85, y: 0.25, hz: 30, band: "gamma", color: "#E74C3C", desc: "Gamma · Upper R" },
      { id: "ring-ul", label: "Upper L", x: 0.15, y: 0.25, hz: 30, band: "gamma", color: "#E74C3C", desc: "Gamma · Upper L" },
      { id: "frontal-r", label: "R Frontal", x: 0.92, y: 0.5, hz: 14, band: "beta", color: "#E67E22", desc: "Beta · Equator R" },
      { id: "frontal-l", label: "L Frontal", x: 0.08, y: 0.5, hz: 14, band: "beta", color: "#E67E22", desc: "Beta · Equator L" },
      { id: "pineal", label: "Pineal Axis", x: 0.5, y: 0.5, hz: 432, band: "alpha", color: "#F1C40F", desc: "432 Hz · Central axis" },
      { id: "ring-lr", label: "Lower R", x: 0.85, y: 0.75, hz: 7.83, band: "alpha", color: "#F1C40F", desc: "7.83 Hz · Lower R" },
      { id: "ring-ll", label: "Lower L", x: 0.15, y: 0.75, hz: 7.83, band: "alpha", color: "#F1C40F", desc: "7.83 Hz · Lower L" },
      { id: "thalamus", label: "Thalamus", x: 0.5, y: 0.32, hz: 6, band: "theta", color: "#9B59B6", desc: "Theta · Upper axis" },
      { id: "brainstem", label: "Brainstem S", x: 0.5, y: 0.95, hz: 2, band: "delta", color: "#4A90E2", desc: "Delta · S pole" },
    ],
    connections: [
      ["crown", "ring-ur"], ["crown", "ring-ul"],
      ["ring-ur", "frontal-r"], ["ring-ul", "frontal-l"],
      ["frontal-r", "ring-lr"], ["frontal-l", "ring-ll"],
      ["ring-lr", "brainstem"], ["ring-ll", "brainstem"],
      ["brainstem", "pineal"], ["pineal", "thalamus"], ["thalamus", "crown"],
      ["ring-ur", "ring-ul"], ["ring-lr", "ring-ll"],
    ],
  },
  {
    id: "golden-spiral",
    name: "GOLDEN SPIRAL",
    short: "φ Spiral",
    description: "Fibonacci spiral (φ = 1.618) seeded from Vesica Piscis — Solfeggio stacking by golden angle.",
    nodes: [
      { id: "pineal", label: "Origin", x: 0.5, y: 0.5, hz: 174, band: "gamma", color: "#E74C3C", desc: "174 Hz · Bindu" },
      { id: "hippocampus-l", label: "L Hippoc.", x: 0.42, y: 0.42, hz: 285, band: "alpha", color: "#F1C40F", desc: "285 Hz" },
      { id: "amygdala-l", label: "L Amygdala", x: 0.36, y: 0.55, hz: 396, band: "alpha", color: "#F1C40F", desc: "396 Hz · Liberation" },
      { id: "temporal-l", label: "L Temporal", x: 0.30, y: 0.72, hz: 417, band: "alpha", color: "#F1C40F", desc: "417 Hz · Change" },
      { id: "brainstem", label: "Brainstem", x: 0.50, y: 0.88, hz: 528, band: "gamma", color: "#E74C3C", desc: "528 Hz · DNA" },
      { id: "temporal-r", label: "R Temporal", x: 0.74, y: 0.78, hz: 639, band: "alpha", color: "#F1C40F", desc: "639 Hz · Connection" },
      { id: "amygdala-r", label: "R Amygdala", x: 0.85, y: 0.58, hz: 741, band: "alpha", color: "#F1C40F", desc: "741 Hz · Expression" },
      { id: "hippocampus-r", label: "R Hippoc.", x: 0.88, y: 0.38, hz: 852, band: "alpha", color: "#F1C40F", desc: "852 Hz · Intuition" },
      { id: "frontal-r", label: "R Frontal", x: 0.76, y: 0.18, hz: 963, band: "gamma", color: "#E74C3C", desc: "963 Hz · Crown" },
      { id: "frontal-l", label: "L Frontal", x: 0.40, y: 0.10, hz: 40, band: "gamma", color: "#E74C3C", desc: "Gamma · Insight" },
      { id: "crown", label: "φ Tail", x: 0.15, y: 0.20, hz: 7.83, band: "alpha", color: "#F1C40F", desc: "7.83 Hz · Earth tail" },
    ],
    connections: [
      ["pineal", "hippocampus-l"], ["hippocampus-l", "amygdala-l"], ["amygdala-l", "temporal-l"],
      ["temporal-l", "brainstem"], ["brainstem", "temporal-r"], ["temporal-r", "amygdala-r"],
      ["amygdala-r", "hippocampus-r"], ["hippocampus-r", "frontal-r"], ["frontal-r", "frontal-l"],
      ["frontal-l", "crown"], ["crown", "pineal"],
    ],
  },
  {
    id: "icosahedron",
    name: "ICOSAHEDRON",
    short: "Icosa",
    description: "20-faced water geometry — limbic regulation, glymphatic flow, emotional fluidity.",
    nodes: [
      { id: "crown", label: "Crown N", x: 0.5, y: 0.06, hz: 33, band: "gamma", color: "#E74C3C", desc: "Gamma · N apex" },
      { id: "prefrontal", label: "Prefrontal", x: 0.5, y: 0.25, hz: 14, band: "beta", color: "#E67E22", desc: "Beta · Forebrain" },
      { id: "frontal-r", label: "R Frontal", x: 0.78, y: 0.32, hz: 18, band: "beta", color: "#E67E22", desc: "Beta · R" },
      { id: "frontal-l", label: "L Frontal", x: 0.22, y: 0.32, hz: 18, band: "beta", color: "#E67E22", desc: "Beta · L" },
      { id: "amygdala-r", label: "R Amygdala", x: 0.68, y: 0.50, hz: 4, band: "theta", color: "#9B59B6", desc: "Theta · R limbic" },
      { id: "amygdala-l", label: "L Amygdala", x: 0.32, y: 0.50, hz: 4, band: "theta", color: "#9B59B6", desc: "Theta · L limbic" },
      { id: "hippocampus-r", label: "R Hippoc.", x: 0.85, y: 0.58, hz: 7.83, band: "alpha", color: "#F1C40F", desc: "7.83 Hz · R memory" },
      { id: "hippocampus-l", label: "L Hippoc.", x: 0.15, y: 0.58, hz: 7.83, band: "alpha", color: "#F1C40F", desc: "7.83 Hz · L memory" },
      { id: "temporal-r", label: "R Temporal", x: 0.62, y: 0.72, hz: 10, band: "alpha", color: "#F1C40F", desc: "Alpha · R" },
      { id: "temporal-l", label: "L Temporal", x: 0.38, y: 0.72, hz: 10, band: "alpha", color: "#F1C40F", desc: "Alpha · L" },
      { id: "occipital", label: "Occipital", x: 0.5, y: 0.80, hz: 6, band: "theta", color: "#9B59B6", desc: "Theta · Vision" },
      { id: "brainstem", label: "Brainstem S", x: 0.5, y: 0.95, hz: 1, band: "delta", color: "#4A90E2", desc: "1 Hz · Glymphatic" },
    ],
    connections: [
      ["crown", "prefrontal"], ["crown", "frontal-r"], ["crown", "frontal-l"],
      ["crown", "hippocampus-r"], ["crown", "hippocampus-l"],
      ["prefrontal", "amygdala-r"], ["prefrontal", "amygdala-l"],
      ["frontal-r", "amygdala-r"], ["frontal-l", "amygdala-l"],
      ["amygdala-r", "temporal-r"], ["amygdala-l", "temporal-l"],
      ["hippocampus-r", "temporal-r"], ["hippocampus-l", "temporal-l"],
      ["temporal-r", "occipital"], ["temporal-l", "occipital"],
      ["occipital", "brainstem"], ["hippocampus-r", "brainstem"], ["hippocampus-l", "brainstem"],
    ],
  },
];

export const GEOMETRY_BY_ID = Object.fromEntries(SACRED_GEOMETRIES.map(g => [g.id, g]));
